import { useEffect, useRef, useState } from 'react'
import { MdClose, MdSearch } from 'react-icons/md'

interface SearchBarProps {
    value: string
    onChange: (value: string) => void
    placeholder?: string
}

export default function SearchBar({
    value,
    onChange,
    placeholder = 'Pesquisar emails...',
}: SearchBarProps) {
    const [localValue, setLocalValue] = useState(value)
    const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    useEffect(() => {
        setLocalValue(value)
    }, [value])

    const handleChange = (newValue: string) => {
        setLocalValue(newValue)
        if (debounceRef.current) clearTimeout(debounceRef.current)
        debounceRef.current = setTimeout(() => {
            onChange(newValue)
        }, 300)
    }

    const handleClear = () => {
        setLocalValue('')
        onChange('')
    }

    return (
        <div className="relative">
            <MdSearch className="absolute z-10 left-3 top-1/2 -translate-y-1/2 text-base-content/40 text-lg z-10" />
            <input
                type="text"
                value={localValue}
                onChange={e => handleChange(e.target.value)}
                placeholder={placeholder}
                className="input input-bordered input-sm w-full pl-9 pr-8"
            />
            {localValue && (
                <button
                    onClick={handleClear}
                    className="absolute right-2 top-1/2 -translate-y-1/2 btn btn-ghost btn-xs btn-circle"
                >
                    <MdClose className="text-sm" />
                </button>
            )}
        </div>
    )
}
